import { useAuth } from '@contexts/authContext';
import '@styles/screens/LandingUnauthorized.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const UnauthorizedLanding = () => {
    const {validationStatus, logOut} = useAuth()
    const navigate = useNavigate()

    const [errorText, setErrorText] = useState('Algo ha salido mal... Vuelve a intentar!')

    useEffect(() => {
        if (validationStatus === 'Not Validated') {
            setErrorText('No eres parte de Qontact aun! Contacta a tus empleadores para activar tu cuenta.')
        } else if (validationStatus === 'No Organizations') {
            setErrorText('No tienes organizaciones que tengan este servicio, vuelve mas tarde!')
        }
    }, [validationStatus])

    return (
        <div className='landing-main' id='app-main'>
            <div className='landing-logo-container'>
              <img className='landing-logo' alt='logo'/>
            </div>
          <div className='landing-frame'>
            <div style={{display: 'flex', flexDirection: 'column',alignItems: 'center', justifyContent: 'center', width: '80%', height: '60%', marginTop: '15%'}}>
                <p className='landing-message'>
                    Oops..!  
                </p>
                <div style={{height:'40px'}}/>
                <p className='landing-message' style={{fontSize: '20px'}}>
                    {errorText}
                </p>
            </div>

            <div style={{width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex', position: 'relative'}}>
              <button className='landing-back-button' 
              onClick={async () => {
                await logOut()
                navigate('/login')
                }}>Volver</button>
              <div className='landing-back-button' style={{position: 'absolute', zIndex: 1, width: '49.2%', top: '6px'}}/>
            </div>
          </div>
        </div>
      );


}

export default UnauthorizedLanding